import React from 'react';

import { t } from '../../../services/i18nService';

import CaptureDeviceStep from '../capturedevice/CaptureDeviceStep';
import FaceCircle from './FaceCircle';

import styles from './photo.scss';

class Photo extends React.PureComponent {
    render() {
        return (
            <div className={styles.photo}>
                <h1>{t('idVerification.photo.title')}</h1>
                <div className={styles.details}>
                    <p>{t('idVerification.photo.steps')}</p>
                    <ul>
                        <li>{t('idVerification.photo.room')}</li>
                        <li>{t('idVerification.photo.face')}</li>
                        <li>{t('idVerification.photo.position')}</li>
                    </ul>
                </div>
                <CaptureDeviceStep>
                    <FaceCircle />
                </CaptureDeviceStep>
            </div>
        );
    }
}

export default Photo;
